import { type CameraElement, ImageType } from '@logistiek-zonder-papier/lzp-library'

export const extractResultFromPhoto: Record<
  ImageType,
  (photo: {
    webPath: string
    format: string
    dataUrl: string
    base64String: string | undefined
  }) => Promise<File | string | undefined>
> = {
  [ImageType.FILE]: async photo => {
    if (!photo.webPath) return undefined

    const blob = await (await fetch(photo.webPath)).blob()

    return new File([blob], `photo_${Date.now()}.${photo.format}`, {
      type: blob.type || `image/${photo.format}`,
    })
  },
  [ImageType.BASE64]: async photo => photo.base64String,
  [ImageType.DATA_URL]: async photo => photo.dataUrl,
}

const LOGO_URL = `/content/img/lzp_logo.png`

const blobToDataUrl = (blob: Blob) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })

export async function getPhoto(config: CameraElement): Promise<File | string | undefined> {
  const blob = await (await fetch(LOGO_URL)).blob()
  const dataUrl = await blobToDataUrl(blob)

  const photo = {
    webPath: LOGO_URL,
    format: 'png',
    dataUrl,
    base64String: dataUrl.split(',')[1],
  }

  return extractResultFromPhoto[config.imageType](photo)
}
